var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vks-viewport-controls",
      attrs: { role: "toolbar", "aria-label": "Canvas controls" },
    },
    [
      _c("div", { staticClass: "vks-zoom-group" }, [
        _c(
          "label",
          { staticClass: "vks-zoom-label", attrs: { for: _vm.zoomSelectId } },
          [_vm._v("Zoom level:")]
        ),
        _c(
          "select",
          {
            staticClass: "gp2-zoom-level-select",
            attrs: { id: _vm.zoomSelectId, "aria-label": "Zoom level" },
            domProps: { value: _vm.viewingRegionWidthBp },
            on: { change: _vm.onZoomLevelChange },
          },
          _vm._l(_vm.zoomLevelOptions, function (option) {
            return _c(
              "option",
              { key: option.widthBp, domProps: { value: option.widthBp } },
              [_vm._v(" " + _vm._s(option.label) + " ")]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "vks-viewport-actions" }, [
        _c(
          "button",
          {
            staticClass: "vks-control-btn",
            class: { "is-active": _vm.dataTableOpen },
            attrs: {
              type: "button",
              title: "Variant data table",
              "aria-label": "Variant data table",
              "aria-expanded": _vm.dataTableOpen ? "true" : "false",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("update:dataTableOpen", !_vm.dataTableOpen)
              },
            },
          },
          [_c("b-icon", { attrs: { icon: "table", "aria-hidden": "true" } })],
          1
        ),
        _c(
          "button",
          {
            staticClass: "vks-control-btn vks-control-btn--assistant",
            class: { "is-active": _vm.aiAssistantOpen },
            attrs: {
              type: "button",
              title: "GP2 Browser actions",
              "aria-label": "GP2 Browser actions",
              "aria-expanded": _vm.aiAssistantOpen ? "true" : "false",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-assistant")
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "vks-control-ai-label",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("Actions")]
            ),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "vks-control-btn",
            class: { "is-active": _vm.settingsOpen },
            attrs: {
              type: "button",
              title: "Settings",
              "aria-label": "Settings",
              "aria-expanded": _vm.settingsOpen ? "true" : "false",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-settings")
              },
            },
          },
          [
            _c("b-icon", {
              attrs: { icon: "gear-fill", "aria-hidden": "true" },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }